import { render } from "./TournamentActivityList.vue?vue&type=template&id=248f80c2&scoped=true"
import script from "./TournamentActivityList.vue?vue&type=script&lang=js"
export * from "./TournamentActivityList.vue?vue&type=script&lang=js"

import "./TournamentActivityList.vue?vue&type=style&index=0&id=248f80c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248f80c2"]])

export default __exports__